var ChildDelimited = React.createClass({
  propTypes: {
    delimiter: React.PropTypes.node,
    className: React.PropTypes.string
  },
  getDefaultProps() {
    return {
      delimiter: " | ",
      className: "" 
    }
  },
  getDelimiter(i) {
    let {delimiter} = this.props;
    let key = `delimiter${i}`;

    if (React.isValidElement(delimiter)) {
      return React.cloneElement(delimiter, {key: key})
    } else {
      return <span key={key}>{delimiter}</span>
    }
  },
  render() {
    let children = React.Children.toArray(this.props.children);
    let items = [];

    children.forEach((child, i) => {
      items.push(child);
      if (i < children.length - 1) {
        items.push(this.getDelimiter(i));
      }
    });

    return (
      <div className={this.props.className}>
        {items}
      </div>
    )
  }
})